import { ReactNode } from "react";
import { OptionIcon } from "./OptionIcon";
import { Option } from "./options";
import { DropDownMenu } from "../../../../../../../../shared/react/dropdown";
import { classes } from "../../../../../../../../shared/react/react";

interface Props {

    options: Option[]
    buttonIcon: ReactNode

    includeSelectedIcon: boolean
    isSelected(option: Option): boolean
    select(option: Option): void

    disabled: boolean

}

export function DropDown({ options, isSelected, select, buttonIcon, includeSelectedIcon, disabled }: Props) {

    const button = <button type="button" className="btn btn-link" disabled={disabled}>
        <OptionIcon icon={buttonIcon} />
    </button>

    return <DropDownMenu button={button} popupCssClass="omnia-holding-permissions" dropdownClass="permissions-cell-dropdown">

        {
            options.map(o =>
                <li role="menuitem" key={o.key}>
                    <a onClick={() => select(o)} className={classes(isSelected(o) && "selected")}>
                        <DropDownItemContent option={o} includeSelectedIcon={includeSelectedIcon} />
                    </a>
                </li>
            )

        }

    </DropDownMenu>


}

function DropDownItemContent({ option, includeSelectedIcon }: { option: Option, includeSelectedIcon: boolean }) {

    return <div className="flex-row spc-5px content">

        {
            includeSelectedIcon &&
            <i className="selected fa-solid fa-check"></i>
        }

        <span style={{ flex: 1 }}>
            {option.name}
        </span>
        <OptionIcon icon={option.dropDownIcon ?? option.icon} />
    </div>

}
